import { StepperSelectionEvent, STEP_STATE } from '@angular/cdk/stepper';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { IDynamicForm, IFormPage, IFormSection, IFormValidatorSection } from './models/form';
import { IFormAutocomplete, IFormCheckbox, IFormDate, IFormFile, IFormLink, IFormNumber, IFormRadio, IFormHidden, IFormSelect, IFormChips, IFormText, IFormPassword, IFormTextarea, IFormValidator, IFormAmount, IFormInfo } from './models/form-cell';
import { openLink, ParamMethod, VariableMethod } from './utils/methods';
import { COMMA, ENTER, BACKSPACE } from '@angular/cdk/keycodes';
import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY } from '@angular/cdk/overlay/typings/overlay-directives';
import { forkJoin, of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface IPagingEvent {
  form: { [control: string]: string };
  previousPage: number;
  currentPage: number;
}
@Component({
  selector: 'dr-form-material',
  templateUrl: './form-material.component.html',
  styleUrls: ['./form-material.component.scss']
})
export class FormMaterialComponent implements OnInit {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  deleteKeysCodes: number[] = [BACKSPACE];
  showForm = false;
  disabledSubmit = true;
  changed = true;
  customForm: FormGroup = new FormGroup({});
  endpointParams = {};
  // tslint:disable-next-line: no-output-native
  @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() formChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() formPrevious: EventEmitter<IPagingEvent> = new EventEmitter<IPagingEvent>();
  @Output() formNext: EventEmitter<IPagingEvent> = new EventEmitter<IPagingEvent>();
  @Output() formEvent: EventEmitter<{ control: string, form: { [key: string]: any } }> = new EventEmitter<{ control: string, form: { [key: string]: any } }>();
  @Output() jsonFormChange: EventEmitter<IDynamicForm> = new EventEmitter<IDynamicForm>();
  @Input() jsonForm: IDynamicForm = null;
  @Input() selectedIndexStep: number = 0;
  @Input() showSpinner: boolean = false;
  @Input() externalVariables: { [k: string]: string | number } = {};
  @Input() changeValues: EventListener = this.handleChangeValues;

  jsonCustomForm: IDynamicForm;
  matStepperSlider: boolean = true;

  fieldValidations: { [name: string]: ValidatorFn[] } = {};
  sectionValidations: { [name: string]: IFormValidatorSection[] } = {};

  jsonControls: { [oldControlName: string]: string } = {}
  jsonValues: { [newControlName: string]: any } = {}

  errorMessage: string = '';

  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;
  startForm: { [ctrl: string]: any } = {};
  resetForm: { [ctrl: string]: any } = {};

  constructor(private _http: HttpClient, private cd: ChangeDetectorRef) {

  }

  handleChangeValues(values: { [k: string]: any }): void {
    Object.keys(values).forEach(k => {
      this.jsonValues[k] = values[k];
      Object.entries(this.jsonControls).filter(f => f[1] === k).map(m => m[0]).forEach(f => {
        this.customForm.controls[f].setValue(values[k]);
      });
    });
    setTimeout(() => {
      this.changed = true;
      this.formChanges();
    });
  }

  ngOnInit(): void {
    try {
      this.errorMessage = '';
      this.jsonCustomForm = JSON.parse(JSON.stringify(this.jsonForm));
      this.jsonCustomForm.language = this.jsonCustomForm.language || navigator.language;
      this.jsonCustomForm.pages = this.jsonCustomForm.pages.sort((a, b) => (a?.position ?? 0) - (b?.position ?? 0));
      if (!!this.jsonCustomForm.positionPageLabel) {
        this.jsonCustomForm.positionPageLabel = this.jsonCustomForm.positionPageLabel.toUpperCase().trim() as any;
        switch (this.jsonCustomForm.positionPageLabel) {
          case 'TOP': case 'BOTTOM':
            this.jsonCustomForm.positionPageLabel = ('CENTER ' + this.jsonCustomForm.positionPageLabel) as any;
            break;
          case 'START': case 'CENTER': case 'END':
            this.jsonCustomForm.positionPageLabel = (this.jsonCustomForm.positionPageLabel + ' BOTTOM') as any;
            break;
        }
      }
      this.initVerifyDuplicates();
      this.initJustify();
      this.createForm();
      // Object.keys(this.jsonValues).forEach(ctrl => {
      //   const mtc_char = /[\<\>\/\"\[\]\:\|\<\>\+\=\;\,\?\*\@\&\ \\]/g;
      //   const inv_char = /^((?![\<\>\/\"\[\]\:\|\<\>\+\=\;\,\?\*\@\&\ \\]).)*$/;
      //   if (!inv_char.test(ctrl)) {
      //     this.errorMessage += `\n'${ctrl}' cannot contains special char! ( ${ctrl.match(mtc_char).map(m => `<b>${m}</b>`).join(' , ')} )`
      //     return;
      //   }
      // });

    } catch (ex) {
      this.errorMessage = ex.error || ex.message || ex.error.message;
    }
  }

  changeStep(evt: StepperSelectionEvent): void {
    this.selectedIndexStep = evt.selectedIndex;
    const el = (this.stepper as any)._elementRef.nativeElement as HTMLDivElement;
    const stepWidth = (el.scrollWidth / this.stepper.steps.length);
    el.scrollTo({
      behavior: 'smooth', top: el.scrollTop, left: ((stepWidth * this.selectedIndexStep) - (el.getBoundingClientRect().width / 2)) + (stepWidth / 2)
    });
  }

  initVerifyDuplicates(): void {
    const controlNames = [];
    this.jsonCustomForm.pages.forEach(page => {
      page.sections.forEach(section => {
        section.rows.forEach(row => {
          row.cells.forEach(cell => {
            let i = 2;
            let controlName = cell.controlName;
            const getControlName = (): string => {
              if (controlNames.includes(controlName)) {
                controlName = cell.controlName + '_' + i;
                i++;
                return getControlName();
              } else {
                // cell.controlName = controlName;
                return controlName;
              }
            }
            let oldControlName = cell.controlName;
            let newControlName = getControlName();
            cell.controlName = newControlName;
            if (!this.jsonValues[newControlName]) {
              this.jsonControls[newControlName] = oldControlName;
              switch (cell.type) {
                case 'DATE': case 'DATETIME':
                  cell.defaultValue = this.isValidDate(cell.defaultValue) ? new Date(cell.defaultValue) : null;
                  break;
                case 'CHECKBOX': case 'RADIO':
                  cell.defaultValue = !!cell.defaultValue;
                  break;
                case 'CHIPS': case 'FILE':
                  cell.defaultValue = cell.defaultValue || [];
                  break;
                case 'INFO':
                  cell.defaultValue = cell.defaultValue || {};
                  break;
                default:
                  cell.defaultValue = cell.defaultValue || ''
                  break;
              }
              this.jsonValues[oldControlName] = cell.defaultValue;
            }
            controlNames.push(newControlName);
          });
        });
      });
    });
  }

  initJustify(): void {
    const chunkify = (a, n, balanced): any[] => {
      if (n < 2) return [a];
      var len = a.length,
        out = [],
        i = 0,
        size;
      if (len % n === 0) {
        size = Math.floor(len / n);
        while (i < len) {
          out.push(a.slice(i, i += size));
        }
      }
      else if (balanced) {
        while (i < len) {
          size = Math.ceil((len - i) / n--);
          out.push(a.slice(i, i += size));
        }
      }
      else {
        n--;
        size = Math.floor(len / n);
        if (len % size === 0)
          size--;
        while (i < size * n) {
          out.push(a.slice(i, i += size));
        }
        out.push(a.slice(size * n));
      }
      return out;
    }

    const originalJSON = { ...this.jsonCustomForm };
    try {
      const MAX_COLSIZE = 6;
      if (this.jsonCustomForm.justified) {
        this.jsonCustomForm.pages.forEach(page => {
          page.sections.forEach(section => {
            section.rows = section.rows.filter(r => r.cells.length > 0);
          });
          page.sections = page.sections.filter(r => r.rows.length > 0);
        });
        this.jsonCustomForm.pages = this.jsonCustomForm.pages.filter(r => r.sections.length > 0);

        this.jsonCustomForm.pages.forEach((page, p) => {
          page.sections.forEach(section => {
            const cells: any[] = [];
            section.rows.forEach(row => {
              row.cells.forEach(cell => {
                if (cell.type === 'CHECKBOX' || cell.type === 'LINK') {
                  cell.cellSize = 1;
                } else {
                  if (cell.type === 'TEXTAREA') {
                    cell.cellSize = 4;
                  } else {
                    cell.cellSize = 2;
                  }
                }
                cells.push(cell);
              });
            });
            const rows = chunkify(cells, Math.round((cells.map(m => m.cellSize).reduce((c, t) => c + t, 0)) / MAX_COLSIZE), true).map(cells => ({ cells, rowSize: cells.map(m => m.cellSize).reduce((c, t) => c + t, 0) }));
            section.rows = rows;
          });
        });
      }
    } catch (ex) {
      this.jsonCustomForm = originalJSON;
      throw ex;
    }
  }

  initDisable(): void {
    this.jsonCustomForm.pages.forEach(page => {
      page.sections.forEach(section => {
        section.rows.forEach(row => {
          row.cells.forEach(cell => {
            if (cell.type !== 'LINK') {
              let disabledGroup = [...cell.disabled || [], ...cell.hidden || [], this.getSectionDisabled(section.disabled)];
              let disabled = disabledGroup.map(d => this.getDisabledExpression(d || false)).filter(f => !!f).length > 0;
              if (disabled !== this.customForm.controls[cell.controlName].disabled) {
                if (disabled) {
                  this.customForm.controls[cell.controlName].disable();
                } else {
                  this.customForm.controls[cell.controlName].enable();
                }
              }
            }
          });
        });
      });
    });
  }

  isValidDate(d: any): boolean {
    try {
      if (d !== null) {
        if (typeof (d) === 'number' && d.toString().length >= 7 && d.toString().length >= 13) {
          return true;
        }
        if ((typeof (d) === 'string' || typeof (d) === 'object') && new Date(d).toString() !== 'Invalid Date') {
          return true;
        }
      }
      return false;
    } catch {
      return false;
    }
  }

  createPanel(template): string {
    const ctrls = Object.keys(this.jsonValues);
    let properties = [];
    ctrls.forEach(ctrl => {
      if (template.includes(ctrl)) {
        var regex = new RegExp(ctrl, 'gi'), result, indices = [];
        while ((result = regex.exec(template))) {
          indices.push(result.index);
        }
        indices.forEach(i => {
          let prop = template.substr(i);
          prop = prop.split(/(?![A-z0-9\_\.])/gi)[0];
          properties.push(prop);
        });
      }
    });
    properties = properties.filter((f, i, a) => a.indexOf(f) === i);
    properties.forEach(p => {
      const ctrl = p.split('.')[0];
      const prop = p.includes('.') ? p.substr(p.indexOf('.') + 1) : '';
      if (this.jsonControls[ctrl] && this.jsonValues[this.jsonControls[ctrl]]) {
        template = template.replace(new RegExp(p, 'gi'), this.getProperty(this.jsonValues[this.jsonControls[ctrl]], prop));
      }
    });
    return template;
  }

  createForm(): void {
    if (!!this.jsonCustomForm) {
      this.jsonCustomForm.pages.forEach(p => {
        p.sections.forEach(s => {
          this.sectionValidations[s.name] = s.validators;
          s.rows.forEach(r => {
            r.cells.forEach(c => {
              this.resetForm[c.controlName] = '';
              if (c.type !== 'LINK') {
                if (c.type !== 'FILE') {
                  switch (c.type) {
                    case 'NUMBER': case 'AMOUNT':
                      c.defaultValue = c.defaultValue || 0;
                      this.resetForm[c.controlName] = 0;
                      break;
                    case 'DATE': case 'DATETIME':
                      c.defaultValue = this.isValidDate(c.defaultValue) ? new Date(c.defaultValue) : null;
                      this.resetForm[c.controlName] = null;
                      break;
                    case 'CHECKBOX': case 'RADIO':
                      c.defaultValue = !!c.defaultValue;
                      this.resetForm[c.controlName] = false;
                      break;
                      case 'CHIPS':
                        c.defaultValue = c.defaultValue || [];
                        this.resetForm[c.controlName] = [];
                      break;
                    default:
                      c.defaultValue = c.defaultValue || ''
                      this.resetForm[c.controlName] = '';
                      break;

                  }
                  // if ((c.type === 'DATE') || (c.type === 'DATETIME')) {
                  //   c.defaultValue = this.isValidDate(c.defaultValue) ? new Date(c.defaultValue) : null;
                  // } else {
                  //   c.defaultValue = c.defaultValue || ((c.type === 'CHECKBOX' || c.type === 'RADIO') ? false : '');
                  //   // if (c.type === 'RADIO' || c.type === 'SELECT' || c.type === 'AUTOCOMPLETE' || c.type === 'CHIPS') {
                  //   //   if (c.endpoint && ParamMethod.contains(c.endpoint) && this.customForm) {
                  //   //     ParamMethod.match(c.endpoint).forEach(param => {
                  //   //       c.endpoint = c.endpoint.replace(param.from, this.customForm.controls[param.control]?.value || '');
                  //   //     });
                  //   //   }
                  //   // }
                  // }
                }
                if ((c.type === 'RADIO' || c.type === 'SELECT' || c.type === 'AUTOCOMPLETE' || c.type === 'CHIPS' || c.type === 'INFO') && !!c.endpoint && !c.observe) {
                  if (ParamMethod.match(c.endpoint).length === 0) {
                    c.observe = this._http.get<any[]>(c.endpoint);
                    if (c.type === 'INFO') {
                      c.observe.subscribe(r => this.jsonValues[this.jsonControls[c.controlName]] = r);
                    }
                  }
                }
                // let disabled = false;
                // ([...c.disabled || [], ...c.hidden || []]).forEach(d => disabled ||= this.getDisabledExpression(d || false));
                if (!!c.controlName) {
                  this.customForm.addControl(c.controlName, new FormControl(c.defaultValue));
                }
              }
            });
          });
        });
      });
      this.jsonCustomForm.pages.forEach(p => p.sections.forEach(s => s.rows.forEach(r => r.cells.forEach(c => c.type !== 'LINK' ? this.initValidators(c) : null))));
      this.initForm();
      // this.initDisable();
    }
  }

  initValidators(
    c: (IFormTextarea | IFormText | IFormPassword | IFormNumber | IFormDate | IFormFile | IFormSelect | IFormChips | IFormRadio | IFormCheckbox | IFormAutocomplete | IFormLink | IFormAmount | IFormHidden | IFormInfo)
  ): void {
    c.validators = c.validators || [];
    if (c.type === 'AMOUNT') {
      if (['it', 'it-IT'].includes(this.jsonCustomForm.language)) {
        c.validators.push({
          value: '^-?0*(?:\\d+(?!\\.)(?:,\\d{1,2})?|(?:\\d{1,3}(?:\\.\\d{3})*(?:,\\d{1,2})?))$',
          type: 'PATTERN',
          error: 'Campo invalido'
        });
      } else {
        c.validators.push({
          value: '^-?0*(?:\\d+(?!,)(?:\\.\\d{1,2})?|(?:\\d{1,3}(?:,\\d{3})*(?:\\.\\d{1,2})?))$',
          type: 'PATTERN',
          error: 'No valid field'
        });
      }
    };
    const validations: IFormValidator[] = [...(c.validators ? c.validators : [])];
    const validators: ValidatorFn[] = [
      ...validations.filter(f => f.type !== 'EXPRESSION').map(m => this.NativeValidator(m, c.type))
    ];
    const expressions = [...validations.filter(f => f.type === 'EXPRESSION')];
    if (!!expressions && expressions.length > 0) {
      expressions.forEach(e => validators.unshift(this.ExpressionValidator(e)));
    }

    // this.customForm.setControl(c.controlName, new FormControl({ value: c.defaultValue || '', disabled }, validators));
    this.customForm.controls[c.controlName].setValidators(validators);

    this.fieldValidations[c.controlName] = validators;
  }

  getHiddenExpressions(hiddens: (boolean | string)[] = []): boolean {
    let isHidden: boolean;

    hiddens.forEach(h => {
      /// FIXARE IN CASO DI CHECBOX SENZA VALUE
      if (typeof (h) === 'string') {
        // tslint:disable-next-line: no-eval
        try {
          isHidden ||= eval(this.InlineExpression(this.customForm.controls, h).toString());
        } catch { }
      } else {
        isHidden ||= h;
      }
    });

    return isHidden;
  }

  getDisabledExpressions(disables: (boolean | string)[] = []): boolean {
    let isDisabled: boolean;

    disables.forEach(h => {
      if (typeof (h) === 'string') {
        // tslint:disable-next-line: no-eval
        try {
          isDisabled ||= eval(this.InlineExpression(this.customForm.controls, h).toString());
        } catch { }
      } else {
        isDisabled ||= h;
      }
    });

    return isDisabled;
  }

  getDisabledExpression(disabled: boolean | string): boolean {
    if (typeof (disabled) === 'string') {
      let d = 'false';
      try {
        d = (this.InlineExpression(this.customForm.controls, disabled).toString());
      } catch { }
      // tslint:disable-next-line: no-eval
      return eval(d);
    } else {
      return disabled;
    }
  }

  formChanges(): void {
    if (this.changed) {
      this.changed = false;
      setTimeout(() => {
        this.disabledSubmit = false;
        this.jsonCustomForm.pages.forEach(page => {
          page.sections.forEach(section => {
            if (!this.getSectionHidden(section.hidden)) {
              this.disabledSubmit ||= !!this.getSectionError(section);
              section.rows.forEach(row => {
                row.cells.forEach(cell => {

                  if (cell.type !== 'LINK') {

                    if (cell.type === 'RADIO' || cell.type === 'SELECT' || cell.type === 'AUTOCOMPLETE' || cell.type === 'CHIPS' || cell.type === 'INFO') {

                      if (cell.endpoint && (ParamMethod.contains(cell.endpoint) || VariableMethod.contains(cell.endpoint)) && this.customForm) {

                        this.endpointParams = this.endpointParams || {};
                        this.endpointParams[cell.controlName] = this.endpointParams[cell.controlName] || {};

                        let change = false;
                        ParamMethod.match(cell.endpoint).forEach((param, pi) => {
                          const paramControl = this.customForm.controls[param.control]?.value?.autocompleteValue || this.customForm.controls[param.control]?.value || '';
                          if (this.endpointParams[cell.controlName][param.from] !== paramControl) {
                            this.endpointParams[cell.controlName][param.from] = paramControl;
                            change = true;
                          }
                        });
                        if (!!Object.keys(this.externalVariables).length) {
                          VariableMethod.match(cell.endpoint, this.externalVariables || {}).forEach((param, pi) => {
                            const variableControl = param.value || '';
                            if (this.endpointParams[cell.controlName][param.from] !== variableControl) {
                              this.endpointParams[cell.controlName][param.from] = variableControl;
                              change = true;
                            }
                          });
                        }

                        let endpoint = cell.endpoint;
                        Object.entries(this.endpointParams[cell.controlName]).forEach(e =>
                          endpoint = endpoint.replace(e[0], e[1] as string));

                        if ((change && (!Object.values(this.endpointParams[cell.controlName]).some(f => !f)) &&
                          (ParamMethod.match(endpoint).length === 0 && VariableMethod.match(endpoint, this.externalVariables).length) === 0)) {
                          cell.observe = this._http.get<any[]>(endpoint);
                          if (cell.type === 'INFO') {
                            cell.observe.subscribe(r => this.jsonValues[this.jsonControls[cell.controlName]] = r);
                          }
                        }

                      }
                    }

                    // let disabled = false;
                    // ([...(cell.disabled || []), ...(cell.hidden || []), this.getSectionDisabled(section.disabled)])
                    //   .forEach(d => disabled ||= this.getDisabledExpression(d || false));
                    // if (disabled !== this.customForm.controls[cell.controlName].disabled) {
                    //   if (disabled) {
                    //     this.customForm.controls[cell.controlName].disable();
                    //   } else {
                    //     this.customForm.controls[cell.controlName].enable();
                    //   }
                    // }
                    this.customForm.controls[cell.controlName].clearValidators();
                    // if (!this.jsonCustomForm.readonly) {

                    this.customForm.controls[cell.controlName].setValidators(this.fieldValidations[cell.controlName]);
                    // }
                    this.customForm.controls[cell.controlName].updateValueAndValidity({ onlySelf: true, emitEvent: true });
                    this.disabledSubmit ||= !!this.customForm.controls[cell.controlName].invalid;
                    // if (this.customForm.controls[cell.controlName].disabled) {
                    //   this.disabledSubmit ||= !!this.customForm.controls[cell.controlName].invalid;
                    // }
                    if (this.jsonCustomForm.readonly) {
                      this.customForm.controls[cell.controlName].disable();
                    }
                  }

                });
              });
            }
          });
        });
        // this.customForm.markAllAsTouched();
        // this.changed = true;
        this.changed = true;
        setTimeout(() => {
          this.jsonFormChange.emit(this.jsonCustomForm);
          this.formChange.emit(this.customForm.value);
        });
      });
    }
  }

  initForm(): void {
    this.startForm = this.customForm.value;
    this.customForm.valueChanges.subscribe(form => {
      if (this.changed) {
        this.formChanges();
        this.initDisable();
      }
    });
    if (this.jsonCustomForm.readonly) {
      setTimeout(() => this.customForm.disable());
    }
    this.showForm = true;
    setTimeout(() => this.stepper._getIndicatorType = () => STEP_STATE.NUMBER);
  }

  getValidPage(page: IFormPage): boolean {
    let validator = true;
    page.sections
      .filter(section => !this.getSectionHidden(section.hidden) && !this.getSectionDisabled(section.disabled))
      .forEach(section => {
        validator &&= !this.getSectionError(section);
        section.rows.forEach(row => row.cells
          .filter(f => f.type !== 'LINK' && !this.customForm.controls[f.controlName].disabled).forEach(cell =>
            validator &&= !this.customForm.controls[cell.controlName].invalid));
      });
    return validator;
  }

  getSectionHidden(hiddens: (boolean | string)[]): boolean {
    const hidden = (hiddens || []).map(m => (typeof (m) !== 'string') ? m :
      eval(this.InlineExpression(this.customForm.controls, m.toString()))).includes(true);
    // this.cd.detach();
    return hidden;
  }

  getSectionHiddenAsync(hiddens: (boolean | string)[]): Observable<boolean> {
    return of(this.getSectionHidden(hiddens))
  }

  getSectionDisabled(disableds: (boolean | string)[]): boolean {
    const disabled = (disableds || []).map(m => (typeof (m) !== 'string') ? m :
      eval(this.InlineExpression(this.customForm.controls, m.toString()))).includes(true);
    return disabled;
  }

  getSectionError(s: IFormSection): string {
    let error = '';
    if (!!s.validators && s.validators.length > 0) {
      s.validators.forEach(validator => {
        const solutionExpression = this.InlineExpression(this.customForm.controls, validator.value);
        let solution = false;
        try {
          // tslint:disable-next-line: no-eval
          solution = eval(solutionExpression);
        } catch {
          solution = true;
        }
        if (!solution && !error) {
          error = validator.error;
        }
      });
    }
    return error;
  }

  getFieldError(c: (IFormTextarea | IFormText | IFormPassword | IFormNumber | IFormDate | IFormFile | IFormSelect | IFormChips | IFormRadio | IFormCheckbox | IFormAutocomplete | IFormLink | IFormAmount | IFormHidden)): string {
    const control = this.customForm.controls[c.controlName];
    const errors = control.errors;
    let errorString = '';
    Object.keys(errors).forEach(errorKey => {
      const myError = {};
      c.validators
        .filter(f => f.type == 'PATTERN')
        // .forEach(f => myError[f.type.toLowerCase()] = f.error);
        .forEach(f => myError[f.type.toLowerCase()] = c.validators.find(f => f.value == errors[errorKey].requiredPattern)?.error);

      let currentError = '';
      switch (errorKey) {
        case 'min':
          currentError = myError[errorKey] || `Enter a minimum digit of ${errors[errorKey].min}`;
          break;
        case 'max':
          currentError = myError[errorKey] || `Enter a maximum digit of ${errors[errorKey].max}`;
          break;
        case 'minlength':
          currentError = myError[errorKey] || `This field must contain at least ${errors[errorKey].requiredLength} characters.`;
          break;
        case 'maxlength':
          currentError = myError[errorKey] || `This field must contain at most ${errors[errorKey].requiredLength} characters.`;
          break;
        case 'required':
          currentError = myError[errorKey] || `Required field.`;
          break;
        case 'pattern':
          // myError[errorKey] = c.validators.find(f => f.value == errors[errorKey].requiredPattern)?.error
          currentError = myError[errorKey] || `Pattern error.`;
          break;
        case 'filesLimit':
          currentError = myError[errorKey] || `You can only upload ${errors[errorKey].max} files.`;
          break;
        case 'expression':
          currentError = errors[errorKey] || `Error expression.`;
          break;
        // aggiungere eventuale gestione di altri errori qui...
        default:
          currentError = `Generic error (${errorKey} ${JSON.stringify(errors[errorKey])})`;
      }
      errorString = errorString.concat(`${currentError}\n`);
      errorString = currentError;
    });

    return errorString;
  }

  getProperty(option: any, propertyName: string): any {
    let property = option;
    try {
      if (!!propertyName) {
        propertyName.split('.').forEach(d => property = property[d]);
      }
    } catch (ex) {
      return property;
    }
    return property;
  }

  fnClickEvent(cell: IFormLink): void {
    const form = {};
    // Object.keys(this.customForm.controls).forEach(control => {
    //   form[control] = (
    //     (typeof (this.customForm.get(control).value) === 'object') && this.customForm.get(control).value?.autocompleteValue)
    //     ? this.customForm.get(control).value.autocompleteValue : this.customForm.get(control).value ?? '';
    // });
    Object.keys(this.jsonValues).forEach(control => {
      form[control] = (
        (typeof (this.jsonValues[control]) === 'object') && this.jsonValues[control]?.autocompleteValue)
        ? this.jsonValues[control].autocompleteValue : this.jsonValues[control] ?? '';
    });
    this.formEvent.emit({ control: cell.controlName, form });
    if (cell.function) {
      cell.function(form);
    } else if (cell.link) {
      openLink(cell.link, !!cell.newPage);
    }
  }

  manageFieldsByType(form: { [key: string]: any }): { [key: string]: any } {
    this.jsonCustomForm.pages.forEach(page => {
      page.sections.forEach(section => {
        section.rows.forEach(row => {
          row.cells.forEach(cell => {
            if (cell.type === 'AMOUNT') {
              if (['it', 'it-IT'].includes(this.jsonCustomForm.language)) {
                form[cell.controlName] = Number(form[cell.controlName].replace(/\./g, '').replace(',', '.'));
              }
            }
          });
        });
      });
    });
    return form;
  }

  matSimpleForm() {
    let form = {};
    Object.keys(this.jsonValues).forEach(control => {
      let value = this.jsonValues[control];
      if (typeof value === 'object') {
        if (Array.isArray(value)) {
          value = value.map(m => m?.autocompleteValue ? m.autocompleteValue : m ?? '');
        } else {
          value = value?.autocompleteValue ? value.autocompleteValue : value ?? '';
        }
      } else {
        value = value ?? ''
      }
      form[control] = value;
    });

    return form;
  }

  matSubmit(): void {
    let form = this.matSimpleForm();
    form = this.manageFieldsByType(form);
    this.formSubmit.emit(form);
  }

  fnPrevious(): void {
    // let pageForm = {};
    // this.jsonCustomForm.pages[this.selectedIndexStep].sections.forEach(s => s.rows.forEach(r => r.cells.forEach(c =>
    //   pageForm[c.controlName] = this.customForm.controls[c.controlName])));
    let form = this.matSimpleForm();
    form = this.manageFieldsByType(form);
    this.formPrevious.emit({ form, previousPage: this.selectedIndexStep, currentPage: this.selectedIndexStep - 1 });
    this.stepper.previous();
  }

  fnReset(): void {
    this.customForm.reset();
    this.customForm.setValue(this.resetForm);
    this.stepper.reset();
    this.formSubmit.emit(null);
  }

  fnNext(): void {
    // let pageForm = {};
    // this.jsonCustomForm.pages[this.selectedIndexStep].sections.forEach(s => s.rows.forEach(r => r.cells.forEach(c =>
    //   pageForm[c.controlName] = this.customForm.controls[c.controlName])));
    let form = this.matSimpleForm();
    form = this.manageFieldsByType(form);
    this.formNext.emit({ form, previousPage: this.selectedIndexStep, currentPage: this.selectedIndexStep + 1 });
    this.stepper.next();
  }

  getLabelChip(o1, o2, v1, v2) {
    return [...o1||[], ...o2||[]].find(f => f[v1] == v2) || v2
  }

  addChipToList(value: any, description: string, cell: IFormChips, chip_input: any) {
    if (!cell.options) {
      cell.options = [];
    }

    if (cell.valueName && cell.descriptionName) {
      value = { [cell.valueName]: value, [cell.descriptionName]: description };
      const option = {
        [cell.valueName]: value,
        [cell.descriptionName]: description
      }
      cell.options.push(option);
    } else {
      value = description;
      const option = description;
      cell.options.push(option);
    }

    this.addChip(cell.controlName, {value}, cell);
    chip_input.value = "";
  }

  addChip(ctrl: string, event: any, cell: IFormChips): void {

    let value = (event?.target || event).value;

    value ||= '';

    const o1 = of(cell.options || []);
    const o2 = cell.observe || of([]);
    forkJoin([o1, o2]).pipe(map(m => [].concat(...m))).subscribe(list => {

      if (!cell.forced) {
        const values = !!cell.valueName ? list.map(m => m[cell.valueName] || m) : list;
        const findin = (values || []).map(m => {
          return m;
        }).find(m => {
          return JSON.stringify(m)?.toLowerCase() == JSON.stringify(value[cell.valueName])?.toLowerCase() || JSON.stringify(m)?.toLowerCase() == JSON.stringify(value)?.toLowerCase();
        });
        value = findin;
      }

      if (value) {
        value = value.autocompleteValue || value;
        if (!this.jsonValues[this.jsonControls[ctrl]].includes(value)) {
          this.jsonValues[this.jsonControls[ctrl]].push(value);
          this.jsonValues[this.jsonControls[ctrl]] = this.jsonValues[this.jsonControls[ctrl]].filter((f, i, a) => a.indexOf(f) === i);
          // event.chipInput!.clear();

          if ((event?.target || event?.input))
            (event?.target || event?.input).value = '';

          this.formChanges();
          // this.jsonControls[ctrl] = '';
        }
      }
    });

  }

  removeChip(ctrl: string, item: string): void {
    const index = this.jsonValues[this.jsonControls[ctrl]].indexOf(item);

    if (index >= 0) {
      this.jsonValues[this.jsonControls[ctrl]].splice(index, 1);
    }
    this.formChanges();
  }

  selectedChip(ctrl: string, event: MatAutocompleteSelectedEvent): void {
    if (!this.jsonValues[this.jsonControls[ctrl]].includes(event.option.value)) {
      this.jsonValues[this.jsonControls[ctrl]].push(event.option.value);
    }
    // this.jsonControls[ctrl] = '';
    // (event?.target || event?.input).value = '';
    this.formChanges();
  }


  getSum(a: any[], k: any): number {
    // tslint:disable-next-line: no-eval
    return Math.round(a.filter(f => !this.getHiddenExpressions(f.hidden || [])).map(m => m[k]).reduce((a, b) => a + b, 0));
    // return Math.round(eval(a.map(m => m[k] || 1).join('+')));
  }

  fnDisplayAutocomplete(event: { autocompleteValue: any, display: string }): string {
    return event?.display;
  }

  fnDisplayChip(event: { autocompleteValue: any, display: string }): string {
    return event?.display;
  }

  NativeValidator(c: IFormValidator, t: string): ValidatorFn {
    switch (c.type) {
      case 'MIN':
        return Validators.min(c.value);
      case 'MAX':
        return (t !== 'FILE') ? Validators.max(c.value) :
          FileUploadValidators.filesLimit(c.value);
      case 'MINLENGTH':
        return Validators.minLength(c.value);
      case 'MAXLENGTH':
        return (t !== 'FILE') ? Validators.maxLength(c.value) :
          FileUploadValidators.fileSize(c.value);
      case 'REQUIRED':
        return Validators.required;
      case 'PATTERN':
        return Validators.pattern(c.value);
    }
  }

  InlineExpression(mainControls: AbstractControl[] | { [key: string]: AbstractControl }, expr: string): string {
    let solutionExpression = expr;
    const getValidValue = (str: string): string => {
      try {
        str = (JSON.parse(str));
        return str;
      } catch {
        return null;
      }
    };

    const exprToVal = (str: string): { formControl?: string, value: any } => {
      let strInput = str;
      let strOutput: { formControl?: string, value: any };
      strInput = strInput;
      const validValue = getValidValue(strInput);
      if (validValue !== null) {
        strOutput = { value: validValue };
        if (typeof (strOutput.value) === 'string') {
          if (strOutput.value.startsWith('"')) { strOutput.value = strOutput.value.substr(1); }
          if (strOutput.value.endsWith('"')) { strOutput.value = strOutput.value.substr(0, strOutput.value.length - 1); }
          strOutput.value = JSON.stringify(strOutput.value);
        }
      } else {
        if (strInput.includes('.')) {
          const k = strInput.substr(0, strInput.indexOf('.'));
          const m = strInput.substr(strInput.indexOf('.') + 1);
          let value = (mainControls[k]?.value || '');

          switch (m.toLowerCase()) {
            case 'length': value = (value.length ?? 0); break;
            case 'lowercase': value = (value as string ?? '')?.toLowerCase(); break;
            case 'uppercase': value = (value as string ?? '')?.toUpperCase(); break;
            case 'titlecase': value = (value as string ?? '')?.toTitleCase(); break;
            default:
              if (typeof value == 'object') {
                value = this.getProperty(value, m)
              }
              break;
          }
          strOutput = { formControl: k, value: JSON.stringify(value) };
        } else {
          if (Object.keys(mainControls).includes(strInput)) {
            strOutput = { formControl: strInput, value: (mainControls[strInput].value ?? '') };
            strOutput.value = JSON.stringify(strOutput.value);
          } else {
            strOutput = { value: strInput };
          }
        }
      }
      return strOutput;
    };
    const recursiveExpression = (inputExpr: string): string => {
      let myExpr = inputExpr;
      if (myExpr.replace(/\".*\(.*\"/gi, '').indexOf('(') > -1 &&
        myExpr.replace(/\".*\).*\"/gi, '').indexOf(')') > -1) {
        while (myExpr.replace(/\".*\(.*\"/gi, '').indexOf('(') > -1 && myExpr.replace(/\".*\).*\"/gi, '').indexOf(')') > -1) {

          const startIndex = myExpr.lastIndexOf('(') + 1;
          let shortExpr = myExpr;
          shortExpr = shortExpr.substr(startIndex);
          shortExpr = shortExpr.substring(0, shortExpr.indexOf(')'));
          const replacedExpr = shortExpr.split(' ').map(m => exprToVal(m).value).join(' ');
          myExpr = myExpr
            .substr(0, startIndex - 1) + '[' +
            recursiveExpression(replacedExpr)
            + ']' + myExpr.substr(startIndex + (shortExpr.length + 1));

        }
      }
      return myExpr.replace(/\[/gi, '(').replace(/\]/gi, ')').split(' ').map(m => exprToVal(m).value).join(' ');
    };

    solutionExpression = recursiveExpression(solutionExpression);

    return solutionExpression;
  }

  ExpressionValidator(expression: IFormValidator): ValidatorFn {

    return (control: AbstractControl): { [key: string]: any } | null => {
      const mainControls = control?.parent?.controls || {};
      const expr = (expression.value ?? '').replace(/\'/gi, '"').replace(/\s{2,}/gi, ' ').trim() as string;
      const solutionExpression = this.InlineExpression(mainControls, expr);
      let solution = false;
      try {
        // tslint:disable-next-line: no-eval
        solution = eval(solutionExpression);
      } catch {
        solution = true;
      }
      return solution ? null : { expression: expression.error };
    };

  }

}
